.wrapper {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.875rem;
}

.headerRow {
	background-color: #f3f4f6;
	color: #111827;
	text-align: left;

	th {
		text-align: center;
	}
}

.bodyRow {
	border-bottom: 1px solid #e5e7eb;
}

.select {
	font-size: 0.875rem;
}

.selectControl {
	min-height: 36px;
	border: 1px solid #d1d5db;
	border-radius: 0.375rem;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.03);
	background-color: white;
}

.selectValueContainer {
	padding: 0.25rem 0.5rem;
}

.input {
	width: 100%;
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
	border: 1px solid #d1d5db;
	border-radius: 0.375rem;
	background-color: white;
	color: #111827;
}

.input:focus {
	outline: none;
	border-color: #568622;
}

.removeButton {
	border: 1px solid;
	border-radius: 5px;
	color: #ef4444;
	background: transparent;
	cursor: pointer;
	transition: color 0.2s;

	&:hover {
		color: #dc2626;
		background-color: rgba(239, 68, 68, 0.1);
	}
}

.removeButton:hover {
	color: #b91c1c;
}

.addButton {
	background-color: #81ba43;
	color: white;
	padding: 0.25rem 1rem;
	font-size: 0.875rem;
	border-radius: 0.375rem;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s;

	&:disabled {
		background-color: #81ba43;
		color: #f0f0f0;
		cursor: not-allowed;
		opacity: 0.8;
	}
}

.addButton:hover {
	background-color: #568622;
}

.footer {
	margin-top: 10px;
}

.footer_text {
	text-align: right;
	font-size: 15px;
	font-weight: 500;
}

.totalLabel {
	font-size: 15px;
	font-weight: 500;
}
